import * as React from 'react';
import {
    BodyLargeRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H5Emphasized,
    Icon,
    isWeb,
    Landmark,
    Sheet,
    View,
    YStack,
} from 'smoothie';

export const NeedsReview = ({ onClose }: { onClose: () => void }) => {
    return (
        <YStack
            flex={1}
            justifyContent={isWeb ? 'flex-start' : 'space-between'}
            gap={isWeb ? 60 : 16}
        >
            <View>
                <View
                    alignSelf="center"
                    padding={25}
                    borderRadius={20}
                    backgroundColor="$white"
                    marginTop={30}
                    marginBottom={30}
                >
                    <Icon icon={Landmark} color="$black" size={30} />
                </View>
                <H5Emphasized textAlign="center" marginBottom={14}>
                    We&apos;re reviewing your account
                </H5Emphasized>
                <BodyLargeRegular textAlign="center" color="$gray1000">
                    We&apos;ll send an email when your linked account is ready
                    to be used.
                </BodyLargeRegular>
            </View>
            <Button
                onPress={() => {
                    onClose();
                }}
                text="Done"
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.LARGE}
            />
        </YStack>
    );
};

export const NeedsReviewSheet = ({
    isOpen,
    onClose,
}: {
    isOpen: boolean;
    onClose: () => void;
}) => {
    return (
        <Sheet isOpen={isOpen} showCloseButton={false} onClose={onClose}>
            <NeedsReview onClose={onClose} />
        </Sheet>
    );
};
